// src/components/ToolCard/index.jsx
import PropTypes from 'prop-types';
import './index.css';
import { Link } from 'react-router-dom';

const iconsPath = `${process.env.PUBLIC_URL}/images/tool-icons`;
const DEFAULT_ICON = `${iconsPath}/default.png`;

const resolveIcon = (toolId) => {
  if (!toolId) return DEFAULT_ICON;
  // 直接拼接图片路径（可支持子目录，如需可自行扩展逻辑）
  return `${iconsPath}/${toolId}.png`;
};

const ToolCard = ({ tool, onVisit }) => {
  const { cateCode, toolCode, code, name, tdesc, url } = tool;
  const toolId = toolCode || code;

  const handleIconError = (e) => {
    e.target.src = DEFAULT_ICON;
  };

  const handleVisit = () => {
    if (onVisit) {
      onVisit(tool);
    } else if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Link to={`/${toolId}`} state={{ cateCode, title: name }} className="tool-card-link" onClick={handleVisit}>
      <div className="tool-card" data-testid="tool-card">
        <div className="tool-icon">
          <img
            src={resolveIcon(toolId)}
            alt={`${name} 图标`}
            onError={handleIconError}
            loading="lazy"
          />
        </div>
        <h3 className="tool-name">{name}</h3>
      </div>
    </Link>
  );
};

// PropTypes 保持不变...
export default ToolCard;